export default class HeaderController {
    static searchOpener() {
        return function openSearch() {
            const searchBar = document.getElementById('header_search_bar'); 
            const navPanels = document.querySelectorAll('.navigation__panel');

            // Hide navigation panels
            navPanels.forEach(panel => panel.classList.add('d-none'));

            if (searchBar && searchBar.classList.contains('d-none')) {
                searchBar.classList.remove('d-none');
                searchBar.classList.add('open');

                const input = searchBar.querySelector(
                    'input.SearchBar__input, input.ProductSearchBar__input'
                );
                input?.focus();

                const event = new CustomEvent('open.search');
                searchBar.dispatchEvent(event);
            }
        };
    }

    static closeSearch() {
        const searchBar = document.getElementById('header_search_bar');

        if (searchBar && searchBar.classList.contains('open')) {
            searchBar.classList.remove('open');
            searchBar.classList.add('d-none');

            const event = new CustomEvent('close.search');
            searchBar.dispatchEvent(event);
        }
    }

    static init() {
        const nav = document.getElementById('main_nav');
        const search = document.querySelector('.header__navigation__search');
        const searchBar = document.getElementById('header_search_bar');

        if (search) {
            search.addEventListener('click', (e) => e.stopPropagation());
        }

        if (nav) {
            nav.addEventListener('shown.bs.collapse', () => {
                setTimeout(() => {
                    document.body.style.position = 'fixed';
                    document.body.style.top = `-${window.scrollY}px`;

                    // Close search when nav opens
                    if (searchBar?.classList.contains('open')) {
                        HeaderController.closeSearch();
                    }
                }, 200);
            });

            nav.addEventListener('hide.bs.collapse', () => {
                const scrollY = document.body.style.top;
                document.body.style.position = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            });
        }
    }
}
